import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "~/components/permission-guard";
import { ensureSession } from "~/modules/auth/credentials";

export const Route = createFileRoute("/_dash/jerboa-client-error")({
  component: RouteComponent,
  beforeLoad() {
    ensureSession();
  },
});

function RouteComponent() {
  return (
    <PermissionGuard permission="jerboa:view">
      <Outlet />
    </PermissionGuard>
  );
}
